<template>
    <div class="io-bar-select">
        <div class="row g-3 mb-3" v-if="showFilter">
            <div class="col-12">
                <md-field class="bordered search">
                    <label>Filtern</label>
                    <md-input v-model="filterString" @input="filterItems"></md-input>
                </md-field>
            </div>
        </div>
        <span class="md-error mb-3 d-block text-danger" v-if="errorMessage !== ''">{{ errorMessage }}</span>
        <div class="row g-3">
            <div :class="barColClass" v-for="item in items">
                <div class="bar" @click="onBarClick">
                    <div class="row align-items-center">
                        <div class="col-auto align-self-center">
                            <div class="input">
                                <slot name="input" v-bind:item="item" v-bind:name="name">
                                    <io-switch
                                        :name="name"
                                        v-model="selectedVals"
                                        :value="item.value"
                                        @toggle="$emit('input', selectedVals)"
                                    >
                                    </io-switch>
                                </slot>
                            </div>
                        </div>
                        <div class="col align-self-center label">
                            <slot v-bind:item="item">
                                <label>
                                    {{ item.label }}
                                </label>
                            </slot>
                        </div>
                        <div class="col-auto align-self-center action">
                            <slot name="action" v-bind:item="item"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IoSwitch from './IoSwitch';

export default {
  name: 'IoBarSelect',

  model: {
    prop: 'selectedValues',
    event: 'input',
  },

  components: {
    IoSwitch,
  },

  props: {
    selectedValues: {
      type: Array,
      default: () => ([]),
    },
    items: {
      type: Array,
      required: true,
    },
    name: {
      required: true,
    },
    barColClass: {
      required: false,
      default: 'col-12',
    },
    errorMessage: {
      required: false,
      default: null,
    },
    showFilter: {
      requried: false,
      default: true,
    },
  },

  data() {
    return {
      selectedVals: this.selectedValues,
      filterString: '',
      $bars: {},
    };
  },

  mounted() {
    this.$bars = this.$el.querySelectorAll('.bar');
  },

  methods: {
    updateValue() {
      this.$emit('input', this.selectedVals);
    },
    filterItems() {
      for (let i = 0; i < this.$bars.length; i++) {
        this.$bars[i].parentNode.classList.remove('d-none');
      }
      if (this.filterString.trim() !== '') {
        for (let i = 0; i < this.$bars.length; i++) {
          if (!this.$bars[i].querySelector('.label').innerText.toLowerCase().includes(this.filterString.trim().toLowerCase())) {
            this.$bars[i].parentNode.classList.add('d-none');
          }
        }
      }
    },
    onBarClick(event) {
      if (!event.target.classList.contains('io-switch')) {
        event.target.closest('.bar').querySelector('.io-switch').click();
      }
    },
  },
};
</script>
